import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { NgxDateRangePickerOptions } from 'src/ngx-daterangepicker';
import { MatSort, MatPaginator, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ExcelgeneratorService } from 'src/app/services/excelgenerator/excelgenerator.service';
import { OrderService } from 'src/app/services/order/order.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-orderdailyreport',
  templateUrl: './orderdailyreport.component.html',
  styleUrls: ['../orderreport/orderreport.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class OrderdailyreportComponent implements OnInit {

  columnsToDisplay = [
    'invoice',
    'origin',
    'createdOn',
    'status',
    'receiver',
    'deliveredby',
    'deliveredon',
    'productName',
    'serialno',
    'rating',
    'pod',
  ];
  selected = '90';
  options: NgxDateRangePickerOptions;
  orderDataArray = new MatTableDataSource();
  page: number = 0;
  excelRecords = [];
  totalRecords: number = 0;
  range = [1, 2, 3, 4, 5];
  daterRangevalue: any;
  fromDate: any;
  isDateFiltered: boolean = false;
  orders = [];
  selectedValue = [];
  isLoading = true;
  maxDate: any;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  isTenantDiag: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private excelService: ExcelgeneratorService,
    private orderService: OrderService
  ) { }

  ngOnInit(): void {
    // this.createInitialFilter();
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.maxDate = new Date();
    this.orderFilter();
  }

  ngAfterViewInit() {
    this.orderDataArray.paginator = this.paginator;
    this.orderDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'user': return item.userSummaryReport.fullName;
      }
    };
    this.orderDataArray.sort = this.sort;
  }


  applyFilter(filterValue: string) {
    this.orderDataArray.filter = filterValue.trim().toLowerCase();
  }

  sortByDate(event: MatDatepickerInputEvent<Date>) {
    this.fromDate = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd');
    this.orderFilter();
  }


  orderFilter() {
    this.orderDataArray.data = [];
    this.orders = [];
    this.isLoading = true;
    this.getData(this.fromDate, this.fromDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
      this.isLoading = false;
      console.log("orders in report", orders);
      // this.dataForExcel(orders);
      if(orders){
      this.orders = orders;
      this.orderDataArray.sortingDataAccessor = (item: any, property) => {
        switch (property) {
          case 'invoice': return item.invoice_number;
          case 'dispatchDate': return item.dispatchDate;
          case 'status': return item.orderstatus;
        }
      };
      this.orderDataArray.data = orders;
      this.orderDataArray.sort = this.sort;
    }
    },()=>{
      this.isLoading = false;
    })
  }

  getData(from, to) {
    let orderStates = ['ORDER_STATE_IN_PLANNING','ORDER_STATE_UNPLANNED', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED', 'ORDER_STATE_INITIAL','ORDER_STATE_SCHEDULED_FOR_PICKUP']
    return this.orderService.getOrderReportByStates(from, to, orderStates);
  }

  orderDetails(orderid) {
    this.orderService.getOrderDetails(Number(orderid) + 1).subscribe(orderData => {
      let editDialog = this.dialog.open(AllorderdetailsComponent, {
        width: '800px',
        data: {
          data: orderData,
        }
      });
      editDialog.updatePosition({
        top: '50px', right: '0px',
      });
    })
  }

  tripDetails(tripId) {
    let tripdialog = this.dialog.open(TripdetailsComponent, {
      width: '800px',
      data: {
        component: 'userreport',
        tripid: tripId,
      }
    });
    tripdialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'dailyorderreport');
  }

  dataForExcel() {
    let ordersData = [];
    console.log(ordersData)
    ordersData = this.orders;
    this.excelRecords = [];
    ordersData.forEach(order => {
      let createdOn, delivereddate, orderstatus, driver, vehicle, comments, dispatchDate, feedbackRating;
      if (order) {

        if (order.created_on)
          createdOn = this.datePipe.transform(order.created_on, "mediumDate");
        else
          createdOn = '-----'

        if (order.delivered_on)
          delivereddate = this.datePipe.transform(order.delivered_on, "medium");
        else
          delivereddate = '-----'

        if (order.dispatchDate)
          dispatchDate = this.datePipe.transform(order.dispatchDate, "mediumDate");
        else
          dispatchDate = '-----'

        if (order.driver)
          driver = order.driver;
        else
          driver = '-----'

        if (order.vehicle)
          vehicle = ', ' + order.vehicle;
        else
          vehicle = ''

        if (order.feedbackComments)
          comments = ', ' + order.feedbackComments;
        else
          comments = ''

        if (order.feedback_rating)
          feedbackRating = order.feedback_rating;
        else
          feedbackRating = ''

        orderstatus = order.orderstatus.slice(12);
      }
      this.excelRecords.push({
        'Order': order.invoice_number || '',
        'Billing From': order.originated_from,
        'Delivery From': order.dispatched_from,
        'Created On': createdOn,
        'Dispatched On': dispatchDate,
        'Status': orderstatus = order ? order.orderstatus.slice(12) : '',
        'Reason': order.failedReason || '',
        'Customer': order.receiver_name || '',
        'Driver': driver || '',
        'Vehicle': vehicle || '',
        'Delivered On': delivereddate,
        'Product Name': order.productName || '',
        'Product Category': order.productCategory || '',
        'Serial No.': order.serial_numbers || '',
        'Customer rating': feedbackRating,
        'Comments': comments || '',
        'POD Available': order ? order.pod_image_exists : '',
      })
    });
  }

  public isMarked = (index, score) => {
    if (score >= index + 1) {
      return 'fa-star';
    }
    else {
      return 'fa-star-o';
    }
  }
}